var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M2.52 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M2.52 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.bda26dae.svg";
export { ForwardRef as ReactComponent };